module.exports = __webpack_public_path__ + "static/media/construction.21b7ef6a.jpg";